import { Autocomplete, Chip, InputBase, createFilterOptions } from "@mui/material";

import "./style.scss";

export interface KBOption {
    uid: string;
    displayName: string;
}

// Trim the typed text before filtering so a stray space (or leading/trailing
// whitespace) doesn't collapse the list to "No options".
const filterOptions = createFilterOptions<KBOption>({ trim: true });

export const KBMultiSelect = ({
    knowledgeBases,
    selectedKBs,
    setSelectedKBs,
    placeholder = "Select Assistants",
    ariaLabel = "Assistants"
}: {
    knowledgeBases: KBOption[];
    selectedKBs: KBOption[];
    setSelectedKBs: (kbs: KBOption[]) => void;
    placeholder?: string;
    ariaLabel?: string;
}) => {
    return (
        <Autocomplete
            multiple
            className="kb-multi-select"
            options={knowledgeBases}
            filterOptions={filterOptions}
            getOptionLabel={option => option.displayName}
            value={selectedKBs}
            onChange={(_event, newValue) => setSelectedKBs(newValue)}
            isOptionEqualToValue={(option, value) => option.uid === value.uid}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        key={option.uid}
                        label={option.displayName}
                        className="kb-multi-select-chip"
                        size="small"
                    />
                ))
            }
            disableCloseOnSelect
            renderInput={params => {
                const { color: _color, size: _size, ...inputProps } = params.inputProps;
                return (
                    <div ref={params.InputProps.ref} className="kb-multi-select-input">
                        {params.InputProps.startAdornment}
                        <InputBase
                            {...inputProps}
                            inputProps={{ "aria-label": ariaLabel }}
                            placeholder={selectedKBs.length === 0 ? placeholder : ""}
                            className="kb-multi-select-input__field"
                        />
                    </div>
                );
            }}
            slotProps={{
                paper: {
                    className: "kb-multi-select-dropdown"
                }
            }}
        />
    );
};
